const convertHexToBase64 = (hexColor: string): string => {
    const color = hexColor.replace('#', '');
    return '%23' + color;
};

export default convertHexToBase64;
